export default __webpack_public_path__ + "static/media/hexagon-inner-12.537819e3.svg";